import { css } from '@mui/styled-engine'

import type { HAVDesignTokensInterface } from '../interfaces'
import { havDefault01Text, havDefault02Text, havH4Text } from './Texts'

const havAccordion = (HAVDesignTokens: HAVDesignTokensInterface) => css`
  #AccordionTitle {
    ${havH4Text(HAVDesignTokens)};
    color: ${HAVDesignTokens.palette.main.secondary};
    margin: auto ${HAVDesignTokens.spacing.stack.big} 0 auto;

    @media (max-width: 767px) {
      font-size: ${HAVDesignTokens.typography.font.size.xx.medium};
    }
  }

  #AccordionSubtitle {
    ${havDefault02Text(HAVDesignTokens)};
    color: ${HAVDesignTokens.palette.neutral.medium};
    white-space: nowrap;

    @media (max-width: 767px) {
      font-size: ${HAVDesignTokens.typography.font.size.xx.small};
    }
  }

  #AccordionSubtitleDescription {
    ${havDefault01Text(HAVDesignTokens)};
    color: ${HAVDesignTokens.palette.neutral.medium};
    margin-top: ${HAVDesignTokens.spacing.inline.x.small};
    white-space: nowrap;

    @media (max-width: 767px) {
      font-size: ${HAVDesignTokens.typography.font.size.x.small};
    }
  }

  border-radius: ${HAVDesignTokens.shape.border.radius.small};
  box-shadow: ${HAVDesignTokens.shape.shadow.rule.first};
  padding: ${`
    ${HAVDesignTokens.spacing.padding.height.big}
    ${HAVDesignTokens.spacing.padding.lenght.medium}
    ${HAVDesignTokens.spacing.padding.height.big}
    ${HAVDesignTokens.spacing.padding.lenght.medium}`};
  margin: 0 !important;

  @media (max-width: 1023px) {
    padding: ${`
      ${HAVDesignTokens.spacing.padding.height.medium}
      ${HAVDesignTokens.spacing.padding.lenght.xsmall}
      ${HAVDesignTokens.spacing.padding.height.medium}
      ${HAVDesignTokens.spacing.padding.lenght.xsmall}`};
  }
  :before {
    background-color: transparent;
  }

  .MuiAccordionSummary-root {
    padding: 0;
    min-height: auto !important;
  }
  :before {
    background-color: transparent;
  }

  .MuiAccordionSummary-contentGutters {
    margin: 0;
  }

  .Mui-expanded .MuiAccordionSummary-contentGutters {
    margin: 0;
    height: auto;
  }
  .MuiAccordionDetails-root {
    border-top: ${`${HAVDesignTokens.shape.border.outline.thin} ${HAVDesignTokens.palette.neutral.light}`};
    padding: 0;
    padding-top: ${HAVDesignTokens.spacing.padding.height.big};
    margin-top: ${HAVDesignTokens.spacing.padding.height.big};
    @media (max-width: 767px) {
      padding-top: ${HAVDesignTokens.spacing.padding.height.medium};
      margin-top: ${HAVDesignTokens.spacing.padding.height.medium};
    }
  }

  .MuiAccordionSummary-root .MuiSvgIcon-root {
    font-size: ${HAVDesignTokens.icon.size.big};
    fill: ${HAVDesignTokens.palette.main.primary};
    @media (max-width: 767px) {
      font-size: ${HAVDesignTokens.icon.size.x.medium};
    }
  }
`

export { havAccordion }
